<template>
  <div :class="classList" class="service-selector-option">
    <button class="select-button" @click="handleClickSelectButton">
      <img :src="icon" class="icon" />
      <div class="meta">
        <h4 class="name">{{ title }}</h4>
      </div>
    </button>
    <div v-if="canRemove" class="action">
      <sc-button
        :icon="true"
        class="no-border"
        variant="clean"
        @click="handleClickRemoveButton"
      >
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    icon: {
      type: null,
      default: undefined,
    },
    title: {
      type: null,
      default: undefined,
    },
    id: {
      type: null,
      default: undefined,
    },
    canSelect: {
      type: null,
      default: undefined,
    },
    canRemove: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    classList() {
      return { selectable: this.canSelect }
    },
  },
  methods: {
    handleClickSelectButton() {
      if (this.canSelect === true) {
        this.$emit("select")
      }
    },
    handleClickRemoveButton() {
      this.$emit("remove")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$padding: 12px ($space / 2);
$hover-bg-color: #f5f5f5;
$border-color: #e0e0e0;

.service-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: $padding;
  transition: background-color 0.2s ease;

  > .select-button {
    cursor: default;
    user-select: text;
    width: 100%;
    text-align: left;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: pointer;
    }

    &:hover {
      background: $hover-bg-color;
    }
  }

  > .action {
    align-self: center;
    margin-right: 8px;
  }

  .no-border {
    border: none !important;
    box-shadow: none !important;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .icon {
    margin-top: 5px;
    flex: 0 0 $logoSize;
    object-fit: contain;
    background-color: #ffffff;
  }

  > .meta {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.icon {
  display: block;
  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 6px;
  object-fit: contain;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #333333;
}

.meta .name {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
</style>
